export const ALERT_AOI_DISPLAY_MAP = "aoi-display-map";
export const ALERT_AOI_EDITOR_MAP = "aoi-editor-map";
export const ALERT_AOI_MAX_AREA = 100000000;
export const KEYWORD_MAX_LIMIT = 50;
export const KEYWORD_MAX_LIMIT_EXT = 100;
export const MAPPED_CONTENT_LIMIT = 1000;
export const CONTENT_SCROLL_LIMIT = { value: 21, type: "days" };

export const WORLD_WIDE_AOI = {
  type: "Feature",
  properties: {
    name: "World Wide AOI",
    aoiIds: null,
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [-180, -90],
        [180, -90],
        [180, 90],
        [-180, 90],
        [-180, -90],
      ],
    ],
  },
};
export const CUSTOM_AOI = {
  type: "Feature",
  properties: { name: "CUSTOM AOI", aoiIds: null },
  geometry: null,
};

export const SHARE_OPTIONS = [
  { id: 1, value: "no", display: "No Thanks" },
  { id: 2, value: "yes", display: "Yes" },
  { id: 3, value: "yes-with-emails", display: "Yes, include emails" },
];

export const AOI_TYPES = {
  default: -1,
  worldWide: 0,
  custom: 1,
};

// NOTE: Do not pull this constant in directly, use the getSources function
// in the services/alerts/alerts.service.js file because some logic needs
// to be done such as checking if the user has Twitter access or not
export const SOURCES = [
  {
    id: "news-all",
    display: "NEWS",
  },
  {
    id: "news-english",
    display: null,
  },
  {
    id: "news-multilingual",
    display: null,
  },
];

export const DEFAULT_SOURCES = ["news-all", "twitter"];

export const EXPIRATION_OPTIONS = [
  { id: 1, name: "1 week", value: 1, type: "weeks" },
  { id: 2, name: "2 weeks", value: 2, type: "weeks" },
  { id: 3, name: "3 weeks", value: 3, type: "weeks" },
  { id: 4, name: "1 month", value: 1, type: "months" },
  { id: 5, name: "2 months", value: 2, type: "months" },
  { id: 6, name: "3 months", value: 3, type: "months" },
];

export const FREQUENCY_OPTIONS = [
  {
    id: "15",
    display: "IMMEDIATELY",
    adverb: "IMMEDIATELY",
    defaultSchedule: "*/15 * * * *",
  },
  {
    id: "60",
    display: "HOUR",
    adverb: "HOURLY",
    defaultSchedule: "50 * * * *",
  },
  {
    id: "1440",
    display: "DAY",
    adverb: "DAILY",
    defaultSchedule: "0 8 * * *",
  },
  {
    id: "10080",
    display: "WEEK",
    adverb: "WEEKLY",
    defaultSchedule: "0 8 * * 7",
  },
  {
    id: "43800",
    display: "MONTH",
    adverb: "MONTHLY",
    defaultSchedule: "0 0 1 * *",
  },
];

export const HOTSPOT_OPTIONS = [
  { id: 0, display: "DISABLED", value: false },
  { id: 1, display: "ENABLED", value: true },
];

export const PULSE_OPTIONS = [
  { id: 0, display: "DISABLED", value: false },
  { id: 1, display: "INCREASED", value: "increase" },
  { id: 2, display: "DECREASED", value: "decrease" },
];

export const VIEW_DETAILS = {
  myAlerts: {
    id: 0,
    size: "40vw",
    minSize: "750px",
  },
  exploreContent: {
    id: 1,
    size: "65vw",
    minSize: "1200px",
  },
  wizard: {
    id: 3,
    size: "60vw",
    minSize: "1000px",
  },
};

export const BASIC_ALERT = function () {
  this.id = null;
  this.name = null;
  this.aoiFeature = {};
  this.frequency = {};
  this.stabilityThreshold = {};
  this.share = {
    type: {},
    list: [],
  };
  this.keywords = {
    includes: [],
    excludes: [],
  };
  this.eventsSelection = {};
  this.verifiedEventsSelection = {
    type: null,
    categories: [],
  };
  this.sources = [];
  this.sendEmail = true;
};

export const ALERTED_CONTENT_ACTION_READ = "read";
export const ALERTED_CONTENT_ACTION_UNREAD = "unread";
export const ALERTED_CONTENT_ACTION_DELETE = "delete";
